// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__31E8W","right":"Footer_right__3b2cd","buttons":"Footer_buttons__1CHZx"};